/**
 *判定値選択絞り込み情報
 */
export type JudgeSettingSelectType = {
  //   バージョン
  /*1:PLC版 2：IOT版*/
  VER: number;
  // インデックス
  JDG_INDEX: number;
  // 非表示フラグ
  /**0：表示，1：非表示  */
  TYP_INVALID: number;
  // メモ1
  MEMO1: string;
  // メモ2
  MEMO2: string;
  // メモ3
  MEMO3: string;
  // メモ4
  MEMO4: string;
  // メモ5
  MEMO5: string;
  // 【計測種別文字列】ユニット種別
  /**KIND_NO_NAME_SET */
  SPEED: number;
  // 【計測種別文字列】名称No.
  /**KIND_NO_NAME_SET */
  NAME_NO: number;
  // 【項目名称】項目名称
  /**NAME_ITME_SET */
  ITM_NAME_NO: number;
  // 【診断タイプ】診断タイプNo.
  /**JDG_TYP_SET */
  TYP_NO_JDG: number;
  // 【演算方法】演算No.
  /**CLC_TYP_SET */
  TYP_NO_CLC: number;
  // 【異常種別】異常種別No.
  /**ALM_KIND_SET */
  TYP_NO_ALM: number;
  // 【演算種別】演算種別ID
  /**MCLC_TYP_ID */
  MCLC_TYP_ID: number;
  // 参照テーブル
  /***/
  REF_TB_NAME: string;

};
/** レスポンス情報 */
export type ResponceDataType = {
  ResponseCode: number;
  ErrorCode: number;
  ResponseMessage: string;
  ErrorMessage: string;
};

/**
 * 判定値選択絞り込み情報取得
 * @returns
 */
export const GetJudgeSettingSelectItems = ()
  : Promise<{ JudgeSettingSelectItems: JudgeSettingSelectType[], ResponceDataModel: ResponceDataType }> => {
  const url = `api/JugeSetSelect/`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: { JudgeSettingSelectItems: JudgeSettingSelectType[], ResponceDataModel: ResponceDataType }) => {
        resolve(result);
      }).catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

/**
 * コナンエア用判定値選択絞り込み情報取得
 * @returns
 */
export const GetJudgeSettingSelectConanItems = ()
  : Promise<{ JudgeSettingSelectItems: JudgeSettingSelectType[], ResponceDataModel: ResponceDataType }> => {
  const url = `api/JugeSetSelect/Conan`;
  console.debug(url);
  return new Promise((resolve, reject) => {
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(message);
        }
        else {
          return res.json();
        }
      })
      .then((result: { JudgeSettingSelectItems: JudgeSettingSelectType[], ResponceDataModel: ResponceDataType }) => {
        resolve(result);
      }).catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

/**
 * 移動平均を追加・書換処理
 * @param devIndex 
 * @returns 
 */
export const SetJudgeSettingLayerShort = (devIndex: number): Promise<ResponceDataType> => {
  console.debug(['SetJudgeSettingLayerShort check', devIndex])
  return new Promise((resolve, reject) => {
    fetch("api/JudgeSetting/LayerShort", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(devIndex),
    })
      .then((res) => res.json())
      .then((result: ResponceDataType) => resolve(result))
      .catch(reason => reject(reason));
  });
}

